// extracted by mini-css-extract-plugin
export default {"wrapper":"ChartWrapper_wrapper__nqnSN","headerWrapper":"ChartWrapper_headerWrapper__h8E36","icon":"ChartWrapper_icon__j1V-B"};